import React, { useState } from "react";
import classNames from "classnames";

/**
 * Provides an input that allow the user to search for a specific value in the table.
 * It uses the useSearch hook to define the field where is going to search the entered value.
 */
export function Search({
  name,
  loading,
  placeholder,
  handleSearchFunction,
  variant = "primary"
}: SearchBarProps) {
  const [searchFieldValue, setSearchFieldValue] = useState("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchFieldValue(event.target.value);
    handleSearchFunction(event.target.value);
  };

  function handleSearchClick() {
    handleSearchFunction(`${searchFieldValue}`);
  }

  return (
    <div
      className={classNames("ui icon input search-bar", {
        loading,
        [variant as string]: variant
      })}
    >
      <input
        aria-describedby={placeholder ?? "Search"}
        id={`${name}-search-input`}
        name={name}
        type="search"
        placeholder={placeholder ?? "Search for..."}
        onChange={handleChange}
        onKeyDown={e => {
          if (e.key === "Enter") {
            if (loading) handleSearchClick();
          }
        }}
        value={searchFieldValue}
      />

      <i
        data-testid="search"
        className="search link icon"
        aria-label="Search Button"
        onClick={handleSearchClick}
      ></i>
    </div>
  );
}

export interface SearchBarProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "value" | "onChange"
  > {
  /**
   * If there will be a delay for search results to appear, set loading boolean for loading icon to appear
   */
  loading?: boolean;
  /**
   * Required.
   * Allows communication of the user's input to be processed by a search function in the parent
   */
  handleSearchFunction: (inputValue: string) => void;
  /**
   * Allows for additional style options to be added
   */
  variant?: "institution-admin" | "primary";
}
